module.exports = "<span [innerHTML]=\"svgIcon\">\n</span>\n\n"